export default {
  headerTraderMode (state) {
    return state.header.traderMode
  },
  isFiltersDisabled (state) {
    return state.filters.isFiltersDisabled
  },
  getPopAside (state) {
    return state.popAside
  },
  asideTransform (state) {
    const { transform } = state.popAside

    if (!transform) return null

    return {
      transform: `translateX(-${transform}px)`
    }
  },
  getPopupPlayers (state) {
    return state.playerWindows
  },
  getEvents (state) {
    return state.events
  },
  isMobile (state) {
    return state.isMobile
  },
  getNotifications (state) {
    return state.notificationsQueue
  }
}
